import * as React from "react";
import { PresenceDot } from "../chat/PresenceDot";
import type { KontaktBetrachter } from "./useContactPresence";

/**
 * Wer die Akte gerade ebenfalls offen hat — kleine Initialen-Kreise im Kopf der
 * Kundenakte. Reine Anzeige; die Daten liefert `useContactPresence`.
 *
 * Die Optik steht inline: contactRedesign.css ist geteilt und wird in dieser
 * Welle von mehreren Änderungen angefasst.
 */

const MAX_SICHTBAR = 4;

function initialen(name: string): string {
  const teile = name.replace(/[^\p{L}\s,.-]/gu, "").split(/[\s,]+/).filter(Boolean);
  const kurz = teile.slice(0, 2).map((w) => w[0]).join("");
  return kurz.toUpperCase() || "?";
}

const KREIS: React.CSSProperties = {
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 28,
  height: 28,
  borderRadius: "50%",
  background: "var(--aub)",
  color: "#fff",
  font: '700 11px/1 "Hanken Grotesk", sans-serif',
  letterSpacing: "0.02em",
  flexShrink: 0,
};

export const ContactPresenceBar: React.FC<{ betrachter: KontaktBetrachter[] }> = ({ betrachter }) => {
  if (betrachter.length === 0) return null;
  const sichtbar = betrachter.slice(0, MAX_SICHTBAR);
  const weitere = betrachter.length - sichtbar.length;
  const namen = betrachter.map((b) => b.displayName).filter(Boolean).join(", ");
  const titel = `Gerade ebenfalls in dieser Akte: ${namen}`;
  return (
    <span
      role="img"
      aria-label={titel}
      title={titel}
      style={{ display: "inline-flex", alignItems: "center", gap: 4, marginRight: 6 }}
    >
      {sichtbar.map((b) => (
        <span key={b.userId} style={KREIS}>
          {initialen(b.displayName)}
          <span style={{ position: "absolute", right: -1, bottom: -1, display: "inline-flex" }}>
            <PresenceDot status="online" size={7} />
          </span>
        </span>
      ))}
      {weitere > 0 && (
        <span style={{ ...KREIS, background: "var(--ink-2)" }}>+{weitere}</span>
      )}
    </span>
  );
};

export default ContactPresenceBar;
